(function ($, Drupal, once) {

  'use strict';

  /**
   * Make the contents of an element automatically to the available size.
   * Children of the target element are 'candidates', and the system works
   * by picking up the first one that fits within the target's allowed width.
   * Candidates need to be pre-sorted in DOM, from the widest to the narrowest.
   */
  Drupal.behaviors.promutuel_autoFitContents = {
    attach: function attach(context) {

      const breakpoints = ['', '-sm', '-md', '-lg', '-xl', '-xxl', '-xxxl'];


      // $(breakpoints.map(bp => `.js${bp}-autofit-contents`).join(','), context).once('promutuel_autoFitContents').each(function () {
      $(once('promutuel_autoFitContents', '.js-autofit-contents', context)).each(function () {
        const candidates = [...this.children];

        autofit(candidates);

        window.addEventListener('resize', event => {
          autofit(candidates);
        });
      });
    }
  };

  /**
   * Automatically select the best fit.
   * Candidates need to be pre-sorted from the widest to the narrowest.
   */
  function autofit(candidates) {
    // Hide all elements.
    candidates.forEach(candidate => {
      candidate.removeAttribute('style');
    });

    let found = false;
    // Check elements one by one, and display the first that fits.
    candidates.forEach(candidate => {
      if (found) return;

      candidate.setAttribute('style', 'display:block !important');
      const parent = candidate.parentElement;
      const parentStyle = window.getComputedStyle(parent);
      const availableWidth = parent.offsetWidth - parseInt(parentStyle.paddingLeft) - parseInt(parentStyle.paddingRight);
      if (candidate.offsetWidth <= availableWidth) {
        found = true;
      }
      else {
        candidate.removeAttribute('style');
      }
    });
  }
})(jQuery, Drupal, once);
